import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface DeleteTransitProps {
  id: string;
}

export const useDeleteTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: DeleteTransitProps) => {
      return request({
        path: `transits/${id}`,
        method: 'DELETE',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success(`Transit deleted!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error deleting the transit!`);
    },
  });
};
